module.exports = __webpack_public_path__ + "img/shopping-cart.37dfe8f0.png";